<template>
    <v-row justify="center">
        <v-dialog
            v-model="companionDialog"
            :persistent='true'
            width="90%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
        <div class="memberAdd">
            <v-card class="cardWrap">
            <CardTitle title="同伴者登録" />
            <div>
                <v-row>
                    <v-col>
                        <v-checkbox
                            v-if="!editingProhibited"
                            class="pl-5"
                            label="予約内容をメールで送信"
                            :input-value="sendFlag"
                            @change="selectSendEmail(sendFlag)"
                        />
                    </v-col>
                </v-row>
                <div v-for="(frame, index) in companionRegist" :key="frame.id" class='margin_buttom20'>
                    <div class="d-flex">
                        <div class="frame_name col-4">
                            <span class='space fontsize-1_5rem'>{{ frame.id }}組目</span>
                            <span class='space fontsize-1_5rem'>{{ frame.course_name }}</span>
                            <span class='space fontsize-1_5rem'>{{ frame.time }}</span>
                        </div>
                        <v-checkbox
                            v-if="true"
                            label="組をキャンセル"
                            class="col-2"
                            :input-value="frame.cell_delete"
                            :disabled="frame.cell_delete_Disable || planId == 0 "
                            @change="selectDeleteCell(index)"
                        />
                        <div v-else class="col-2"/>
                            <v-btn
                                color="primary"
                                class="col-2"
                                large
                                @click="OnSelectCompanion(index)"
                                :disabled="frame.cell_delete"
                                >同伴者リスト
                            </v-btn>
                        <div class="col-2"/>
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="frame.players"
                        class="golfGroupTbody"
                        hide-default-footer
                        >
                        <template v-slot:[`item.family_name`]="{ item }">
                            <v-text-field
                                item-value="code"
                                item-text="name"
                                v-model.trim="item.family_name"
                                :disabled="item.disableFlag || frame.cell_delete"/>
                            </template>
                        <template v-slot:[`item.given_name`]="{ item }">
                            <v-text-field
                                item-value="code"
                                item-text="name"
                                v-model.trim="item.given_name"
                                :disabled="item.disableFlag || frame.cell_delete"/>
                            </template>
                        <template v-slot:[`item.email`]="{ item }">
                        <v-text-field
                            item-value="code"
                            item-text="name"
                            v-model.trim="item.email"
                            :disabled="item.disableFlag || frame.cell_delete"
                            />
                        </template>
                        <template v-slot:[`item.mobile_number`]="{ item }">
                        <v-text-field
                            item-value="code"
                            item-text="name"
                            v-model.trim="item.mobile_number"
                            :disabled="item.disableFlag || frame.cell_delete"
                            />
                        </template>
                        <template v-slot:[`item.member_class`]="{ item }">
                            <v-select
                                :items="memberClassSelectItem"
                                item-value="code"
                                item-text="code_name"
                                v-model="item.member_class"
                                :disabled="item.disableFlag || frame.cell_delete"
                                />
                        </template>
                        <template v-slot:[`item.visited_code`]="{ item }">
                            <v-select
                                :items="visitorClassSelectItem"
                                item-value="code"
                                item-text="name"
                                v-model="item.visited_code"
                                :disabled="item.visitedDisableFlag || frame.cell_delete"
                                />
                        </template>
                        <template v-slot:[`item.clearBtn`]="{ item }">
                            <v-btn
                                small
                                @click="PushClearButton(frame.id,item.id,item.email)"
                                class="editBtn"
                                :disabled="item.clearButtonDisableFlag || frame.cell_delete">クリア
                            </v-btn>
                        </template>
                        <template v-slot:[`item.addBtn`]="{ item }">
                            <v-btn
                            small
                            color="primary"
                            @click="onAddButton(frame.id,item.id)"
                            class="editBtn"
                            :disabled="item.addBtnDisable || frame.cell_delete || planId == 0 ">席追加
                            </v-btn>
                        </template>
                        <template v-slot:[`item.cancelBtn`]="{ item }">
                            <v-btn
                                small
                                color="error"
                                @click="onCancelButton(frame.id,item.id)"
                                class="editBtn"
                                :disabled="item.cancelBtnDisable || frame.cell_delete || planId == 0 ">席削除
                            </v-btn>
                        </template>
                    </v-data-table>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="CloseDialog">閉じる</v-btn>
                    <v-btn color="green darken-4" text @click="OnAddStartTime" :disabled="reserveType === '2' || planId == 0 ">スタート時間追加</v-btn>
                    <v-btn color="green darken-4" text @click="OnNext">変更</v-btn>
                </v-card-actions>
            </div>
            </v-card>
        </div>
        <ChangeOverlay
            page-name="同伴者"
            @processing="MakeUpdateCompanionList"
            @cancel="changeOverlay = !changeOverlay"
            :process-result="process"
            :OverlaySwitch="changeOverlay"
        />
        <ConfirmOverlay
            page-name="同伴者"
            @processing="MakeUpdateCompanionList"
            @cancel="confirmOverlay = !confirmOverlay"
            :process-result="process"
            :OverlaySwitch="confirmOverlay"
        />
        <SelectCompanion
            ref="SelectCompanionView"
            @select-companion="OnSelect"
            @close-select-companion="CloseModal"
            v-show="selectCompanion"
        />
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
import ConfirmOverlay from '@/views/Master/page/overlay/ConfirmOverlay';
import SelectCompanion from './SelectCompanion';
import { CODE_MASTER } from '../../config';
import { UPDATE_COMPANION, GET_RESERVE_COMPANION } from '../../../constants/companion';
import { GET_CODE_KEY_LIST } from '@/constants/codelist';
import { GET_EMAIL_SEARCH_MEMBER_CLASS, GET_REPRESENTATIVE_PROFILE } from '../../../constants/member';
import { COMPLETE_RESERVE_EMAIL } from '../../../constants/reserve';
import validater from '../../../lib/validater';

export default {
    components: {
        CardTitle,
        ChangeOverlay,
        ConfirmOverlay,
        SelectCompanion
    },
    data () {
        return {
            // テーブルのヘッダー
            headers: [
                { text: '', value: 'idName', align: 'center', sortable: false, width: '10%' },
                { text: '名前', value: 'family_name', sortable: false, width: '7%' },
                { text: '', value: 'given_name', sortable: false, width: '7%' },
                { text: 'メールアドレス', value: 'email', sortable: false, width: '24%' },
                { text: '携帯番号', value: 'mobile_number', sortable: false, width: '12%' },
                { text: '会員区分', value: 'member_class', sortable: false, width: '7%' },
                { text: '来場実績', value: 'visited_code', sortable: false, width: '7%' },
                { text: '', value: 'clearBtn', sortable: false, width: '2%' },
                { text: '', value: 'addBtn', sortable: false, width: '2%' },
                { text: '', value: 'cancelBtn', sortable: false, width: '2%' }
            ],
            // セレクトボックス
            memberClassSelectItem: null,
            cellId: null,
            visitorClassSelectItem: [
                { code: 0, name: '予約済み' },
                { code: 1, name: '来場済み' },
                { code: 2, name: 'キャンセル' }
            ],
            classListArray: [{}],
            companionRegist: [],
            reserveType: null,
            // 予約番号 (仮親からもらう予定)
            reserveNo: null,
            memberNo: null,
            playerMin: null,
            companionDialog: false,
            selectCompanion: false,
            processing: false,
            changeOverlay: false,
            confirmOverlay: false,
            // エラーメッセージ
            error: '',
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            representative: [],
            loadingCount: 0,
            sendFlag: true,
            editingProhibited: true,
            // 最小予約人数
            minNumber: null,
            // 最大予約人数
            maxNumber: null,
            deleteCell: [],
            // プランID
            planId: 0
        };
    },
    created () {
        this.Initialize();
    },
    methods: {
        async Initialize () {
        },
        /** ----------------------------------------------
         * ダイアログを開く
         * @reserveNo 親からもらってくる予約番号
         * ---------------------------------------------- */
        OpenDialog: async function (reserveNo, editingProhibited, reservePlanId) {
            this.loadingOn();
            this.editingProhibited = editingProhibited;
            this.reserveNo = reserveNo;
            this.planId = reservePlanId;
            // await this.createCompanionList();
            await this.GetMyProfile();
            await this.GetCompanion(reserveNo);
            // await this.GetCompanionList(editingProhibited);
            await this.GetFlagCodeList();
            this.loadingOff();
        },
        /** ----------------------------------------------
         * ログインユーザー情報取得
         * ---------------------------------------------- */
        GetMyProfile: async function () {
            var me = this;
            try {
                me.loadingOn();
                await this.$apollo.mutate({
                    mutation: GET_REPRESENTATIVE_PROFILE,
                    variables: {
                        reserve_no: me.reserveNo
                    }
                }).then(res => {
                    me.representative = res.data.getRepresentativeProfile.Profile[0];
                    if (me.representative.member_class) {
                        me.representative.member_class = String(me.representative.member_class);
                    }
                    me.loadingOff();
                });
            } catch (error) {
                me.loadingOff();
                me.error = error;
                me.$store.commit('loading/setIsLoading', false);
            }
        },
        /** ----------------------------------------------
         * 同伴者一覧取得
         * ---------------------------------------------- */
        GetCompanion: async function (reserveNo) {
            var me = this;
            try {
                var result = await this.$apollo.query({
                    query: GET_RESERVE_COMPANION,
                    fetchPolicy: 'no-cache',
                    variables: {
                        reserve_no: reserveNo
                    }
                });
                var dataList = result.data.GetReserveCompanionFromAdmin.ReserveCompanions;
                me.memberNo = dataList[0].member_no;
                me.minNumber = dataList[0].player_min;
                me.maxNumber = dataList[0].player_max;
                me.reserveType = dataList[0].reserve_type;
                me.sendFlag = Boolean(dataList[0].send_play_together_email_flag);
                var cel = -1;
                var play = 0;
                // 予約者判定フラグ
                // var repre = false;
                for (let data of dataList) {
                    // 同伴者データに取得してきた枠IdがcompanionRegist無かったまたは
                    // companionRegistがなかったら同伴者リストを作成
                    if (me.companionRegist.length === 0 || !me.companionRegist.some((el) => (el.cell_id === data.cell_id))) {
                        await this.createCompanionList(data);
                        cel++;
                        play = 0;
                    }

                    if (data.class_no !== 99) {
                        // 取得してきたデータのclass_noが99ではなかったら
                        // companionRegistにセットする
                        me.companionRegist[cel].players[play].reserve_no = data.plt_reserve_no;
                        me.companionRegist[cel].players[play].member_no = data.plt_member_no;
                        me.companionRegist[cel].players[play].old_family_name = data.family_name;
                        me.companionRegist[cel].players[play].family_name = data.family_name;
                        me.companionRegist[cel].players[play].old_given_name = data.given_name;
                        me.companionRegist[cel].players[play].given_name = data.given_name;
                        me.companionRegist[cel].players[play].old_email = data.email;
                        me.companionRegist[cel].players[play].email = data.email;
                        me.companionRegist[cel].players[play].mobile_number = String(data.mobile_number).replace(/-|null/g, '');
                        me.companionRegist[cel].players[play].old_mobile_number = String(data.old_mobile_number).replace(/-|null/g, '');
                        me.companionRegist[cel].players[play].gender = data.gender;
                        me.companionRegist[cel].players[play].era = data.era;
                        me.companionRegist[cel].players[play].profile = data.profile;
                        me.companionRegist[cel].players[play].score_level = data.score_level;
                        me.companionRegist[cel].players[play].enthusiasm = data.enthusiasm;
                        me.companionRegist[cel].players[play].nickname = data.nickname;
                        me.companionRegist[cel].players[play].old_member_class = data.member_class;
                        me.companionRegist[cel].players[play].member_class = data.member_class;
                        me.companionRegist[cel].players[play].visited_code = data.visited_code;
                        me.companionRegist[cel].players[play].addBtnDisable = true;
                        me.companionRegist[cel].players[play].cancelBtnDisable = false;
                        me.companionRegist[cel].players[play].disableFlag = true;
                        me.companionRegist[cel].players[play].clearFlag = false;

                        // 会員区分がなかったらビジターにする
                        if (data.member_class === null) {
                            me.companionRegist[cel].players[play].member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                            me.companionRegist[cel].players[play].old_member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                        }
                        // 会員なら編集できなくする
                        if (data.plt_member_no) {
                            me.companionRegist[cel].players[play].disableFlag = true;
                        }

                        // 予約番号の不一致でシェア予約と判断し編集できないようにする
                        if (me.companionRegist[cel].players[play].reserve_no !== me.reserveNo || this.editingProhibited) {
                            me.companionRegist[cel].players[play].clearButtonDisableFlag = true;
                            me.companionRegist[cel].players[play].addBtnDisable = true;
                            me.companionRegist[cel].players[play].cancelBtnDisable = true;
                            me.companionRegist[cel].players[play].disableFlag = true;
                            me.companionRegist[cel].players[play].visitedDisableFlag = true;
                        } else {
                            me.companionRegist[cel].players[play].disableFlag = false;
                        }

                        // 予約者の場合、クリア,追加,キャンセルを非活性にする。監視用フラグも変更する。
                        if (me.companionRegist[cel].players[play].member_no === me.memberNo) {
                            me.companionRegist[cel].players[play].clearButtonDisableFlag = false;
                            me.companionRegist[cel].players[play].addBtnDisable = true;
                            me.companionRegist[cel].players[play].cancelBtnDisable = false;
                            me.companionRegist[cel].players[play].disableFlag = true;
                            // 予約者の入っている組は削除出来なくする。
                            // me.companionRegist[cel].cell_delete_Disable = true;
                            // repre = true;
                            // representativeCheckflag = false;
                        }

                        play++;
                    }
                }
                await this.ChangeDisableReserveNumber();
                // this.SetMyProfile(repre);
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 予約人数によるボタン及び入力エリア非活性処理
         * ---------------------------------------------- */
        ChangeDisableReserveNumber: async function (cel) {
            var me = this;
            // 通常予約の場合
            if (me.reserveType === CODE_MASTER.RESERVE_TYPE_NORMAL) {
                for (var i = 0; i < me.companionRegist.length; i++) {
                    for (var j = me.companionRegist[i].cell_player_number; j < me.companionRegist[i].players.length; j++) {
                        me.companionRegist[i].players[j].addBtnDisable = false;
                        me.companionRegist[i].players[j].cancelBtnDisable = true;
                        me.companionRegist[i].players[j].disableFlag = true;
                        me.companionRegist[i].players[j].clearButtonDisableFlag = true;
                        me.companionRegist[i].players[j].visitedDisableFlag = true;
                    }
                }
            } else {
                for (var k = 0; k < me.companionRegist.length; k++) {
                    var cellNumber = me.companionRegist[k].cell_player_number;
                    // 予約人数と残りの空き席数を合算し入力可能席数を算出する
                    var okNumber = me.companionRegist[k].player_left;
                    for (var l = 0; l < me.companionRegist[k].players.length; l++) {
                        // 予約番号が一致したら入力可能席数を減らす
                        if (me.companionRegist[k].players[l].reserve_no === me.reserveNo) {
                            cellNumber--;
                        }
                    }
                    for (var m = 0; m < me.companionRegist[k].players.length; m++) {
                        // cellNumberとokNumberが0でもプレーヤの空きがあったら他の予約されているプレーヤなので
                        // 非活性にする
                        if (okNumber <= 0 && cellNumber <= 0 && !me.companionRegist[k].players[m].reserve_no) {
                            me.companionRegist[k].players[m].addBtnDisable = true;
                            me.companionRegist[k].players[m].cancelBtnDisable = true;
                            me.companionRegist[k].players[m].disableFlag = true;
                            me.companionRegist[k].players[m].clearButtonDisableFlag = true;
                            me.companionRegist[k].players[m].visitedDisableFlag = true;
                        }
                        // 入力可能席数が1以上残っていたら予約番号が入力されていないプレーヤー追加ボタンを活性化する。
                        if (okNumber >= 1 && cellNumber <= 0 && !me.companionRegist[k].players[m].reserve_no) {
                            if (me.companionRegist[k].players[m].reserve_no === null) {
                                me.companionRegist[k].players[m].addBtnDisable = false;
                                me.companionRegist[k].players[m].cancelBtnDisable = true;
                                me.companionRegist[k].players[m].disableFlag = true;
                                me.companionRegist[k].players[m].clearButtonDisableFlag = true;
                                me.companionRegist[k].players[m].visitedDisableFlag = true;
                                okNumber--;
                            }
                        }
                        // cellNumberが1以上残っていたら登録していない同伴者があるので
                        // 残っている席数分活性化させる。
                        if (cellNumber >= 1 && !me.companionRegist[k].players[m].reserve_no) {
                            if (me.companionRegist[k].players[m].reserve_no === null) {
                                me.companionRegist[k].players[m].addBtnDisable = true;
                                me.companionRegist[k].players[m].cancelBtnDisable = false;
                                me.companionRegist[k].players[m].disableFlag = false;
                                me.companionRegist[k].players[m].clearButtonDisableFlag = false;
                                me.companionRegist[k].players[m].visitedDisableFlag = false;
                                cellNumber--;
                            }
                        }
                    }
                }
            }
        },
        /** ----------------------------------------------
         * ログインユーザー情報セット（）
         * @param {Boolean} repre 同伴者一覧に代表者いたかチェック結果
         * ---------------------------------------------- */
        SetMyProfile: function (repre) {
            var me = this;
            // 同伴者一覧に代表者がいたら終了
            if (repre) {
                return;
            }
            // 同伴者一覧に代表者がいなかったら
            // 入力できるプレーヤー欄を探す
            for (let cell of me.companionRegist) {
                for (let player of cell.players) {
                    // 追加ボタンが非活性、キャンセルボタンが活性、氏名が入ってないプレーヤー欄があったら
                    // そこに代表者情報をセットする
                    if (player.addBtnDisable && !player.cancelBtnDisable && (!player.family_name && !player.given_name)) {
                        player.reserve_no = me.reserveNo;
                        player.old_family_name = me.representative.family_name;
                        player.family_name = me.representative.family_name;
                        player.old_given_name = me.representative.given_name;
                        player.given_name = me.representative.given_name;
                        player.email = me.representative.email;
                        player.old_email = me.representative.email;
                        player.mobile_number = me.representative.mobile_number;
                        player.old_mobile_number = me.representative.old_mobile_number;
                        player.gender = me.representative.gender;
                        player.era = me.representative.era;
                        player.profile = me.representative.profile;
                        player.score_level = me.representative.score_level;
                        player.enthusiasm = null;
                        player.nickname = me.representative.nickname;
                        player.visited_code = 0;
                        player.member_no = me.memberNo;
                        player.clearFlag = false;
                        player.disableFlag = true;
                        player.clearButtonDisableFlag = false;
                        player.addBtnDisable = true;
                        player.cancelBtnDisable = false;
                        // cell.cell_delete_Disable = true;
                        // 会員区分がなかったらビジターにする
                        if (!me.representative.member_class) {
                            player.member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                            player.old_member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                        } else {
                            player.member_class = me.representative.member_class;
                            player.old_member_class = me.representative.member_class;
                        }
                        // 一度セットしたら終わり
                        return;
                    }
                }
            }
        },
        /** ----------------------------------------------
         * 削除cellリストチェック
         * @param {int} index 選択されたcompanionRegistの配列番号
         * ---------------------------------------------- */
        selectDeleteCell: function (index) {
            var me = this;
            me.companionRegist[index].cell_delete = !me.companionRegist[index].cell_delete;
        },
        /** ----------------------------------------------
         * 同伴者email送信フラグ切り替え
         * @param {Boolean} sendFlag 選択されたemail送信フラグ
         * ---------------------------------------------- */
        selectSendEmail: function (sendFlag) {
            this.sendFlag = !sendFlag;
        },
        /** ----------------------------------------------
         * 同伴者配列を作成
         * ---------------------------------------------- */
        createCompanionList: function (data) {
            var id = this.companionRegist.length + 1;
            var companions = {
                id: id,
                cell_delete: false,
                cell_delete_Disable: false,
                cell_player_number: data.cell_player_number,
                player_left: data.player_left,
                course_name: data.course_name,
                time: data.play_start.slice(0, -3),
                cell_id: data.cell_id,
                players: [
                    {
                        id: 1,
                        idName: 'プレーヤー1',
                        member_no: null,
                        reserve_no: null,
                        old_family_name: null,
                        family_name: null,
                        old_given_name: null,
                        given_name: null,
                        old_email: null,
                        email: null,
                        mobile_number: null,
                        old_mobile_number: null,
                        gender: null,
                        era: null,
                        profile: null,
                        score_level: null,
                        enthusiasm: null,
                        nickname: null,
                        old_member_class: null,
                        member_class: null,
                        visited_code: null,
                        addBtnDisable: true,
                        cancelBtnDisable: false,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    },
                    {
                        id: 2,
                        idName: 'プレーヤー2',
                        member_no: null,
                        reserve_no: null,
                        old_family_name: null,
                        family_name: null,
                        old_given_name: null,
                        given_name: null,
                        old_email: null,
                        email: null,
                        mobile_number: null,
                        old_mobile_number: null,
                        gender: null,
                        era: null,
                        profile: null,
                        score_level: null,
                        enthusiasm: null,
                        nickname: null,
                        old_member_class: null,
                        member_class: null,
                        visited_code: null,
                        addBtnDisable: true,
                        cancelBtnDisable: false,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    },
                    {
                        id: 3,
                        idName: 'プレーヤー3',
                        member_no: null,
                        reserve_no: null,
                        old_family_name: null,
                        family_name: null,
                        old_given_name: null,
                        given_name: null,
                        old_email: null,
                        email: null,
                        mobile_number: null,
                        old_mobile_number: null,
                        gender: null,
                        era: null,
                        profile: null,
                        score_level: null,
                        enthusiasm: null,
                        nickname: null,
                        old_member_class: null,
                        member_class: null,
                        visited_code: null,
                        addBtnDisable: true,
                        cancelBtnDisable: false,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    },
                    {
                        id: 4,
                        idName: 'プレーヤー4',
                        member_no: null,
                        reserve_no: null,
                        old_family_name: null,
                        family_name: null,
                        old_given_name: null,
                        given_name: null,
                        old_email: null,
                        email: null,
                        mobile_number: null,
                        old_mobile_number: null,
                        gender: null,
                        era: null,
                        profile: null,
                        score_level: null,
                        enthusiasm: null,
                        nickname: null,
                        old_member_class: null,
                        member_class: null,
                        visited_code: null,
                        addBtnDisable: true,
                        cancelBtnDisable: false,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    }
                ]
            };
            this.companionRegist.push(companions);
        },
        /** ----------------------------------------------
         * 同伴者入力項目チェック
         * ---------------------------------------------- */
        CheckCompanionValidater: function () {
            var me = this;
            var count = 0;
            var emailList = [];
            var mobileList = [];
            var representativeFlag = true;
            for (let frame of me.companionRegist) {
                for (let player of frame.players) {
                    // キャンセルボタン活性、組をキャンセルにチェックが入っていない枠のみ確認
                    if (!player.cancelBtnDisable && !frame.cell_delete) {
                        // メールの正規表現が誤りだったら
                        if (player.email && !validater.checkMail(player.email)) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.mailFormat');
                            this.changeOverlay = true;
                            return false;
                        // 携帯番号の正規表現が誤りだったら
                        } else if (player.mobile_number && !validater.checkmobilenumberNoHyphen(player.mobile_number)) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.mobileNumber');
                            this.changeOverlay = true;
                            return false;
                        // メールまたは携帯番号が入力されているのに性または名前が入力されていなかったら
                        } else if ((player.email || player.mobile_number) && (!player.family_name && !player.given_name)) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.nameEmpty');
                            this.changeOverlay = true;
                            return false;
                        //  名前が入力されているのに来場実績と会員区分が設定されていなかったら
                        } else if ((player.family_name || player.given_name) && player.visited_code === null && player.member_class === null) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.visitedAndClassEmpty');
                            this.changeOverlay = true;
                            return false;
                        // 名前が入力されているのに来場実績が設定されていなかったら
                        } else if ((player.family_name || player.given_name) && player.visited_code === null) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.visitedCodeEmpty');
                            this.changeOverlay = true;
                            return false;
                        // 名前が入力されているのに会員区分が設定されていなかったら
                        } else if ((player.family_name || player.given_name) && player.member_class === null) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.memberClassEmpty');
                            this.changeOverlay = true;
                            return false;
                        } else if (emailList.includes(player.email)) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.duplicateEmail');
                            this.changeOverlay = true;
                            return false;
                        } else if (mobileList.includes(player.mobile_number)) {
                            this.process.result = 1;
                            this.process.resultText = this.$t('error.validation.duplicateMobile');
                            this.changeOverlay = true;
                            return false;
                        }
                        if (player.member_no === this.memberNo) representativeFlag = true;
                        if (player.email) emailList.push(player.email);
                        if (player.mobile_number) mobileList.push(player.mobile_number);
                    }
                    if (!frame.cell_delete) {
                        count++;
                    }
                }
            }
            // 全ての組がキャンセルされていたら。
            if (count === 0) {
                this.process.result = 1;
                this.process.resultText = this.$t('error.validation.allCancel');
                this.changeOverlay = true;
                return false;
            }
            // 代表者がいなかったら。

            if (!representativeFlag) {
                this.process.result = 1;
                this.process.resultText = this.$t('error.validation.representativeEmpty');
                this.changeOverlay = true;
                return false;
            }
            // 問題無ければ
            return true;
        },
        /** ----------------------------------------------
         * 削除する枠にプレーヤー情報があるか確認。
         * ---------------------------------------------- */
        CheckDeleteCellInPlayer: function () {
            var me = this;
            for (let frame of me.companionRegist) {
                for (let player of frame.players) {
                    if (frame.cell_delete && (player.family_name || frame.given_name)) {
                        me.process.result = '';
                        me.process.resultText = this.$t('message.cellCancel');
                        me.confirmOverlay = true;
                        return true;
                    }
                }
            }
        },
        /** ----------------------------------------------
         * 登録ボタン押す
         * ---------------------------------------------- */
        OnNext: async function () {
            // チェックがNGだったら止める
            if (!this.CheckCompanionValidater()) return;
            if (this.CheckDeleteCellInPlayer()) return;
            this.process.result = '';
            this.changeOverlay = true;
        },
        /** ----------------------------------------------
         * 同伴者登録
         * ---------------------------------------------- */
        MakeUpdateCompanionList: async function () {
            var me = this;
            me.confirmOverlay = false;
            me.changeOverlay = false;
            this.processing = true;
            let data = [];
            let reserves = [];
            var cellCount = 0;
            var numberCount = 0;
            var id = 0;
            // チェックがNGだったら止める
            // if (!this.CheckCompanionValidater()) return;
            for (let frame of me.companionRegist) {
                var playerNo = 1;
                if (!frame.cell_delete) {
                    id++;
                    reserves.push({
                        reserve_no: me.reserveNo,
                        player_number: null,
                        cell_number: null,
                        cell_id: frame.cell_id,
                        cell_player_number: frame.cell_player_number,
                        cell_change_flag: 1
                    });
                    numberCount = frame.cell_player_number + numberCount;
                    cellCount++;
                    for (let player of frame.players) {
                        let obj = {};
                        // 名前が入力されていれば
                        if ((player.member_no === me.memberNo || !player.cancelBtnDisable)) {
                            // 取得されていた情報と一致(変更はされていない)していればchange_flagを0にする
                            if ((player.family_name === player.old_family_name) &&
                                (player.given_name === player.old_given_name) &&
                                (player.email === player.old_email) &&
                                (player.mobile_number === player.old_mobile_number) &&
                                (player.member_class === player.old_member_class) &&
                                (player.clearFlag === false)) {
                                obj = {
                                    reserve_no: player.reserve_no,
                                    cell_id: frame.cell_id,
                                    class_no: id,
                                    player_no: playerNo,
                                    family_name: player.family_name,
                                    given_name: player.given_name,
                                    email: player.email,
                                    mobile_number: player.mobile_number,
                                    gender: player.gender,
                                    era: player.era,
                                    profile: player.profile,
                                    score_level: player.score_level,
                                    enthusiasm: player.enthusiasm,
                                    nickname: player.nickname,
                                    member_class: player.member_class,
                                    visited_code: player.visited_code,
                                    member_no: player.member_no,
                                    change_flag: 1,
                                    send_play_together_email_flag: Number(this.sendFlag),
                                    reserve_type: me.reserveType
                                };
                                data.push(obj);
                                playerNo++;
                            // 追加されていればchange_flagを1にする
                            } else if (player.clearFlag === true) {
                                obj = {
                                    reserve_no: me.reserveNo,
                                    cell_id: frame.cell_id,
                                    class_no: id,
                                    player_no: playerNo,
                                    family_name: player.family_name,
                                    given_name: player.given_name,
                                    email: player.email,
                                    mobile_number: player.mobile_number,
                                    gender: 0,
                                    era: null,
                                    profile: null,
                                    score_level: null,
                                    enthusiasm: null,
                                    nickname: null,
                                    member_class: player.member_class ? player.member_class : CODE_MASTER.MEMBER_CLASS_VISITOR,
                                    visited_code: player.visited_code ? player.visited_code : CODE_MASTER.RESERVE_SITUATION_NOW,
                                    member_no: player.member_no,
                                    change_flag: 1,
                                    send_play_together_email_flag: Number(this.sendFlag),
                                    reserve_type: me.reserveType
                                };
                                data.push(obj);
                                playerNo++;
                            // 取得されていた情報と一致しなければ(変更された)change_flagを2にする
                            } else if (((player.family_name !== player.old_family_name) ||
                                (player.given_name !== player.old_given_name) ||
                                (player.email !== player.old_email) ||
                                (player.mobile_number !== player.old_mobile_number) ||
                                (player.member_class !== player.old_member_class)) &&
                                (player.reserve_no === me.reserveNo)) {
                                obj = {
                                    reserve_no: player.reserve_no,
                                    cell_id: frame.cell_id,
                                    class_no: id,
                                    player_no: playerNo,
                                    family_name: player.family_name,
                                    given_name: player.given_name,
                                    email: player.email,
                                    mobile_number: player.mobile_number,
                                    gender: 0,
                                    era: null,
                                    profile: null,
                                    score_level: null,
                                    enthusiasm: null,
                                    nickname: null,
                                    member_class: player.member_class,
                                    visited_code: player.visited_code,
                                    member_no: player.member_no,
                                    change_flag: 1,
                                    send_play_together_email_flag: Number(this.sendFlag),
                                    reserve_type: me.reserveType
                                };
                                data.push(obj);
                                playerNo++;
                            }
                            // id++;
                        }
                        obj = null;
                    }
                } else {
                    reserves.push({
                        reserve_no: me.reserveNo,
                        player_number: null,
                        cell_number: null,
                        cell_id: frame.cell_id,
                        cell_player_number: 0,
                        cell_change_flag: 2
                    });
                }
            }

            for (let res of reserves) {
                res.player_number = numberCount;
                res.cell_number = cellCount;
            }
            // 同伴者登録
            me.UpdateCompanion(data, reserves);
        },
        /** ----------------------------------------------
         * 同伴者登録
         * @data 同伴者データ
         * @reserves 予約番号のリスト{reserve_no:予約番号,player_number:人数}
         * ---------------------------------------------- */
        UpdateCompanion: async function (data, reserves) {
            var me = this;
            this.$apollo.mutate({
                mutation: UPDATE_COMPANION,
                variables: {
                    CompanionList: data,
                    ReserveNumbers: reserves
                }
            }).then(res => {
                me.confirmOverlay = false;
                if (res.data.UpdateCompanionFromAdmin.result === 2) {
                    me.process.result = 1;
                    me.process.resultText = this.$t('result.error.duplicateReserve');
                    this.changeOverlay = true;
                    return;
                }
                me.MakeMailSendObject(data);
                me.companionRegist = [];
                me.companionDialog = false;
                this.$emit('close-companion');
            }).catch(err => {
                me.confirmOverlay = false;
                me.process.result = 1;
                me.process.resultText = this.$t('result.error.change');
                me.changeOverlay = true;
                me.processing = false;
                me.error = err;
            });
        },
        /** ----------------------------------------------
         * メール送信用オブジェクト作成
         * ---------------------------------------------- */
        MakeMailSendObject: async function (data) {
            var me = this;
            var reserveEmailData = [];
            var startTime = [];
            for (let cell of me.companionRegist) {
                startTime.push(cell.time);
            }
            if (me.sendFlag && !me.editingProhibited) {
                for (let player of data) {
                    if (player.email && player.reserve_no === me.reserveNo) {
                        let reserveEmailObj = {
                            email: player.email,
                            reserve_no: me.reserveNo,
                            family_name: player.family_name,
                            given_name: player.given_name,
                            start_time: startTime,
                            point: null,
                            edit_flag: true
                        };
                        reserveEmailData.push(reserveEmailObj);
                    }
                }
                // メール送信用のメソッドを実行する
                if (reserveEmailData) {
                    me.CompleteReserveEmailSend(reserveEmailData);
                }
            }
        },
        /** ----------------------------------------------
         * 予約完了メール送信
         * @data メール送信用オブジェクト
         * ---------------------------------------------- */
        CompleteReserveEmailSend: async function (data) {
            try {
                await this.$apollo.mutate({
                    mutation: COMPLETE_RESERVE_EMAIL,
                    variables: {
                        ReserveEmail: data
                    }
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * email入力時の会員区分取得
         * @frameId 枠のID
         * @playerId プレイヤーID
         * @email 入力されたメールアドレス
         * ---------------------------------------------- */
        GetEmailSearchMemberClass (frameId, playerId, email) {
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_EMAIL_SEARCH_MEMBER_CLASS,
                variables: {
                    email: email,
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                frameId--;
                playerId--;
                this.companionRegist[frameId].players[playerId].member_class = res.data.GetEmailSearchMemberClass.member_class;
                this.companionRegist.splice();
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * キャンセルボタンを押下
         * @frameId 枠のID
         * @playerId プレイヤーID
         * ---------------------------------------------- */
        onCancelButton: function (frameId, playerId) {
            var me = this;
            frameId--;
            playerId--;
            if ((me.companionRegist[frameId].cell_player_number - 1) < me.minNumber && me.reserveType === CODE_MASTER.RESERVE_TYPE_NORMAL) {
                me.process.result = 1;
                me.process.resultText = '最小予約人数は' + me.minNumber + '名からです。';
                this.changeOverlay = true;
                return;
            } else if ((me.companionRegist[frameId].cell_player_number - 1) < 1 && me.reserveType === CODE_MASTER.RESERVE_TYPE_SHARE) {
                me.process.result = 1;
                me.process.resultText = '最小予約人数は1名からです。';
                this.changeOverlay = true;
                return;
            }
            me.companionRegist[frameId].cell_player_number--;
            me.companionRegist[frameId].players[playerId].disableFlag = true;
            me.companionRegist[frameId].players[playerId].visitedDisableFlag = true;
            me.companionRegist[frameId].players[playerId].clearButtonDisableFlag = true;
            me.companionRegist[frameId].players[playerId].addBtnDisable = false;
            me.companionRegist[frameId].players[playerId].cancelBtnDisable = true;
        },
        /** ----------------------------------------------
         * 追加ボタンを押下
         * @frameId 枠のID
         * @playerId プレイヤーID
         * ---------------------------------------------- */
        onAddButton: function (frameId, playerId) {
            var me = this;
            frameId--;
            playerId--;
            if ((me.companionRegist[frameId].cell_player_number + 1) > me.maxNumber && me.reserveType === CODE_MASTER.RESERVE_TYPE_NORMAL) {
                me.process.result = 1;
                me.process.resultText = '最大予約人数は' + me.maxNumber + '名までです。';
                this.changeOverlay = true;
                return;
            }
            me.companionRegist[frameId].cell_player_number++;
            if (me.companionRegist[frameId].players[playerId].member_no) {
                me.companionRegist[frameId].players[playerId].disableFlag = true;
            } else {
                me.companionRegist[frameId].players[playerId].disableFlag = false;
            }
            me.companionRegist[frameId].players[playerId].visitedDisableFlag = false;
            me.companionRegist[frameId].players[playerId].clearButtonDisableFlag = false;
            me.companionRegist[frameId].players[playerId].addBtnDisable = true;
            me.companionRegist[frameId].players[playerId].cancelBtnDisable = false;
        },
        /** ----------------------------------------------
         * 同伴者リスト表示
         * @param {int} index 配列の番号
         * ---------------------------------------------- */
        OnSelectCompanion: function (index) {
            var me = this;
            var count = 0;
            let id = 0;
            for (let player of me.companionRegist[index].players) {
                // キャンセルボタンが活性化されていてなおかつ
                // 氏名、メールが入っていなければ入力できるカウントを取る
                if (!player.cancelBtnDisable && !player.family_name && !player.given_name && !player.email) {
                    count++;
                }
            }
            // 入力できるスペースが無ければ
            if (count === 0) {
                me.process.result = 1;
                me.process.resultText = this.$t('error.validation.notInputSpace');
                this.changeOverlay = true;
                return;
            }
            let selectedPlayer = [];
            for (let frame of me.companionRegist) {
                if (!frame.cell_delete) {
                    id++;
                    for (let player of frame.players) {
                        if (player.family_name || player.given_name) {
                            selectedPlayer.push({
                                class_no: id,
                                player_no: player.id,
                                family_name: player.family_name,
                                given_name: player.given_name,
                                email: player.email,
                                mobile_number: player.mobile_number
                            });
                        }
                    }
                }
            }
            this.selectCompanion = true;
            this.$refs.SelectCompanionView.GetCompanionList(this.reserveNo, this.memberNo, count, index, me.representative, selectedPlayer);
        },
        /** ----------------------------------------------
         * 同伴者リスト表示
         * @param {array} playerList 同伴者リストで選択されたプレーヤー
         * @param {int} index 配列の番号
         * ---------------------------------------------- */
        OnSelect: function (playerList, index) {
            var me = this;
            var i = 0;
            for (let player of me.companionRegist[index].players) {
                // キャンセルボタンが活性化されていてなおかつ
                // 氏名、メールが入っていなければ入力する
                if (!player.cancelBtnDisable && !player.family_name && !player.given_name && !player.email && !player.mobile_number) {
                    player.reserve_no = playerList[i].reserve_no;
                    player.family_name = playerList[i].family_name;
                    player.given_name = playerList[i].given_name;
                    player.email = playerList[i].email;
                    player.mobile_number = playerList[i].mobile_number;
                    player.gender = playerList[i].gender;
                    player.era = playerList[i].era;
                    player.profile = playerList[i].profile;
                    player.score_level = playerList[i].score_level;
                    player.enthusiasm = playerList[i].enthusiasm;
                    player.nickname = playerList[i].nickname;
                    player.visited_code = playerList[i].visited_code;
                    player.member_no = playerList[i].member_no;
                    if (!playerList[i].member_class) {
                        player.member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                    } else {
                        player.member_class = String(playerList[i].member_class);
                    }
                    if (player.member_no === me.memberNo) {
                        player.disableFlag = true;
                    }
                    i++;
                    if (playerList.length <= i) return;
                }
            }
        },
        CloseModal: function () {
            this.selectCompanion = false;
        },
        /** ----------------------------------------------
         * クリアボタンを押下
         * @frameId 枠のID
         * @playerId プレイヤーID
         * ---------------------------------------------- */
        PushClearButton: function (frameId, playerId, email) {
            var me = this;
            frameId--;
            playerId--;
            me.companionRegist[frameId].players[playerId].member_no = null;
            me.companionRegist[frameId].players[playerId].family_name = null;
            me.companionRegist[frameId].players[playerId].given_name = null;
            me.companionRegist[frameId].players[playerId].email = null;
            me.companionRegist[frameId].players[playerId].mobile_number = null;
            me.companionRegist[frameId].players[playerId].member_class = null;
            me.companionRegist[frameId].players[playerId].visited_code = null;
            me.companionRegist[frameId].players[playerId].clearFlag = true;
            me.companionRegist[frameId].players[playerId].disableFlag = false;
        },
        /** ----------------------------------------------
         * ダイアログを閉じる
         * ---------------------------------------------- */
        CloseDialog: function () {
            this.companionRegist = [];
            this.representative = [];
            this.companionDialog = false;
            this.$emit('close-companion');
        },
        /** ----------------------------------------------
         * スタート時間追加
         * ---------------------------------------------- */
        OnAddStartTime: function () {
            this.companionRegist = [];
            this.companionDialog = false;
            this.$emit('add-start-time');
        },
        /** --------------------------------------------
        * 来場実績だけ変更可能
        * -------------------------------------------- */
        changeVisitCodeOnly: function (editingProhibited) {
            var me = this;
            if (editingProhibited) {
                for (let list of me.companionRegist) {
                    for (let player of list.players) {
                        if (player.given_name === null && player.family_name === null && player.email == null && player.mobile_number == null) {
                            player.clearButtonDisableFlag = true;
                            player.disableFlag = true;
                            player.visitedDisableFlag = true;
                        }
                    }
                }
            }
        },
        /** --------------------------------------------
        * コードリスト取得(会員区分)
        * -------------------------------------------- */
        GetFlagCodeList: async function () {
            var me = this;
            me.loadingOn();
            try {
                this.$apollo.query({
                    fetchPolicy: 'no-cache',
                    query: GET_CODE_KEY_LIST,
                    variables: {
                        codeKeyList: ['member_class']
                    }
                }).then(res => {
                    me.memberClassSelectItem = res.data.GetCodeListByKeys.CodeKeyRecList[0].codeRec;
                    me.loadingOff();
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * プロフィール表示切替
         * @companionListArray 同伴者一覧
         * @representativeCheckflag 同伴者一覧に代表者がいたかのフラグ
         * ---------------------------------------------- */
        profileButtonSwitching: function (companionListArray, representativeCheckflag) {
            var me = this;
            var count = 0;
            if (companionListArray.length >= 1) {
                for (let list of me.companionRegist) {
                    for (let player of list.players) {
                        if ((player.reserve_no === me.reserveNo ||
                            player.reserve_no === null) &&
                            me.reserveType === CODE_MASTER.RESERVE_TYPE_SHARE) {
                            player.pofileFlag = true;
                        }
                        // 代表者が入っていなくて記入がされていなければ代表者を入れる
                        if (representativeCheckflag &&
                            player.family_name === null &&
                            player.given_name === null &&
                            player.email === null &&
                            player.mobile_number === null &&
                            this.reserveType === CODE_MASTER.RESERVE_TYPE_SHARE) {
                            if (count === 0) {
                                player.member_no = me.memberNo;
                                player.family_name = me.representative.family_name;
                                player.given_name = me.representative.given_name;
                                player.email = me.representative.email;
                                player.mobile_number = me.representative.mobile_number;
                                player.displayFlag = true;
                                player.selectFlag = true;
                                count++;
                            }
                            player.pofileFlag = true;
                        } else if (representativeCheckflag &&
                                   player.family_name === null &&
                                   player.given_name === null &&
                                   player.email === null &&
                                   player.mobile_number === null &&
                                   this.reserveType === CODE_MASTER.RESERVE_TYPE_NORMAL) {
                            player.member_no = me.memberNo;
                            player.family_name = me.representative.family_name;
                            player.given_name = me.representative.given_name;
                            player.email = me.representative.email;
                            player.mobile_number = me.representative.mobile_number;
                            player.displayFlag = true;
                            player.selectFlag = true;
                        }
                    }
                }
            }
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount === 0) {
                this.companionDialog = true;
            }
        }
    }
};

</script>

<style scoped>

.margin_buttom20{
    margin-top: 50px;
}

.frame_name{
    padding-left: 2%;
}

.space{
    margin-left: 1rem;
}
.fontsize-1_5rem{
    font-size: 1.5rem;
    font-weight: bold;
}

</style>
